import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { PlusIcon, MinusIcon } from '@heroicons/react/solid'
import clsx from 'clsx'
import AnimateHeight from 'react-animate-height'

const Accordion = ({
    text,
    content,
    hasBorder = true,
    isEquipmentInfo = false,
    forceClose = false,
    onIsOpen = null,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleIsOpen = () => {
        setIsOpen(!isOpen)
        if (onIsOpen) {
            onIsOpen(isOpen)
        }
    }

    useEffect(() => {
        forceClose === false && setIsOpen(false)
    }, [forceClose])

    return (
        <div
            className={clsx(
                'border-gray-200 overflow-hidden',
                hasBorder && 'border-b',
                isEquipmentInfo ? 'pb-4 lg:w-96 w-full px-0' : 'py-6 w-full',
            )}
        >
            <AnimateHeight
                className="m-auto"
                id="acoordion-panel"
                duration={500}
                height={isOpen ? 'auto' : '40px'}
            >
                <div
                    className={clsx('flex flex-col items-center justify-start')}
                >
                    <div
                        onClick={toggleIsOpen}
                        className={clsx(
                            'h-auto flex flex-row items-center justify-between cursor-pointer',
                            isEquipmentInfo ? 'lg:w-96 w-full' : 'w-full',
                        )}
                    >
                        <p className="text-sm font-medium text-black70 ">
                            {text}
                        </p>
                        <button
                            className={clsx(
                                'flex items-center justify-center appearance-none border-0',
                                isEquipmentInfo && 'px-0',
                            )}
                        >
                            {isOpen ? (
                                <MinusIcon className="text-black70  w-4 stroke-1" />
                            ) : (
                                <PlusIcon className="text-black70  w-4 stroke-1" />
                            )}
                        </button>
                    </div>
                    <div
                        className={clsx(
                            `w-full max-w-full text-center transition-height ease-in-out`,
                        )}
                    >
                        {isOpen && content}
                    </div>
                </div>
            </AnimateHeight>
        </div>
    )
}

Accordion.propTypes = {
    content: PropTypes.node.isRequired,
    text: PropTypes.string.isRequired,
    hasBorder: PropTypes.bool,
    isEquipmentInfo: PropTypes.bool,
    forceClose: PropTypes.bool,
    onIsOpen: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
}

export default Accordion
